import PropTypes from "prop-types";
import React from "react";
import { Redirect } from "react-router-dom";
import { NavLoader } from "ui/loader";
import { genCancelSourceOptions } from "util/request";

class FetchController extends React.PureComponent {
  static get propTypes() {
    return {
      children: PropTypes.node,
      fetchObject: PropTypes.func.isRequired,
      injectAs: PropTypes.string,
      object: PropTypes.any,
      objectId: PropTypes.string.isRequired,
      objectLoaded: PropTypes.bool.isRequired,
      unloadObject: PropTypes.func,
    };
  }

  static get defaultProps() {
    return {
      injectAs: "object",
    };
  }

  constructor(props) {
    super(props);

    this.cancelSource = null;
    this._isMounted = false;

    this._beginFetch = this._beginFetch.bind(this);
    this._shouldFetch = this._shouldFetch.bind(this);

    this.state = {
      inFlight: false,
      lastId: props.objectId,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this._beginFetch();
  }

  componentDidUpdate() {
    if (this._shouldFetch()) {
      this._beginFetch();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    // Clear UI state
    const { unloadObject } = this.props;

    if (this.cancelSource) {
      this.cancelSource.cancel();
    }

    if (unloadObject) {
      unloadObject();
    }
  }

  _beginFetch(opts) {
    const doFetch = this._doFetch.bind(this, opts);

    const { objectId, unloadObject } = this.props;
    if (unloadObject) {
      unloadObject();
    }

    this.setState({ inFlight: true, lastId: objectId }, doFetch);
  }

  _doFetch(opts = {}) {
    const { objectId, fetchObject } = this.props;
    const params = {};

    const options = {
      ...opts,
      ...genCancelSourceOptions(),
    };
    this.cancelSource = options.cancelSource;

    return fetchObject(objectId, params, options).finally(() => {
      if (this._isMounted) {
        this.setState({ inFlight: false });
      }
    });
  }

  _shouldFetch() {
    const { objectId } = this.props;
    const { lastId, inFlight } = this.state;

    return !inFlight && objectId !== lastId;
  }

  render() {
    const { children, injectAs, objectLoaded, object } = this.props;
    const { inFlight } = this.state;

    if (inFlight) {
      return <NavLoader.Proxy key="fetch">Fetching...</NavLoader.Proxy>;
    }

    if (!objectLoaded) {
      return <NavLoader.Proxy key="stores" />;
    }

    if (!object) {
      return <Redirect to="/404" />;
    }

    if (children) {
      return React.cloneElement(children, { [injectAs]: object });
    }

    return null;
  }
}

export { FetchController };
